import { render, staticRenderFns } from "./DocumentProcessor.vue?vue&type=template&id=007ac2a8&"
import script from "./DocumentProcessor.vue?vue&type=script&lang=ts&"
export * from "./DocumentProcessor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports